// axios
import axios from 'axios'
import VueCookies from 'vue-cookies'
import { getEnv } from '@/env'
import { de } from 'date-fns/locale';

const axiosIns = axios.create({
  baseURL: getEnv('VUE_APP_FRONTEND_API_URL'),
  withCredentials: true,
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
  },
})

// Interceptor to read device_id from cookies after the response
axiosIns.interceptors.response.use(
  response => {
    const headers = response?.headers || {};
    const device_id = headers['x-device-id'];
    const device_id_exp = headers['x-device-id-exp'];

    if (device_id && device_id_exp) {
      localStorage.setItem('device_id', device_id);
      localStorage.setItem('device_id_exp', device_id_exp);
    }

    return response;
  },
  error => {
    return Promise.reject(error);
  }
);

export default axiosIns
